import { Component, OnInit, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from "@angular/material";
import { ApiCallsService } from "@app/routes/dashboard/pages/dashboard/api-call-service";
import { FormControl, FormGroup, Validators } from "@angular/forms";
 
import { Router } from "@angular/router";
 
@Component({
  selector: "app-livealerts",
  templateUrl: "./livealerts.component.html",
  styleUrls: ["./livealerts.component.css"],
 
})
export class LivealertsComponent implements OnInit {
  Lastcolor: any;
  Datacolor: any;
  LastTime: any;
  HMIIMageScreen: any;
  isAdding: boolean = false;  
  isDeleting: boolean = false;
  selectedPlant = "TCII";
  userForm: FormGroup;
  edituserForm: FormGroup;
  public count = 0;
  allUsers: any;
  Message: any;
  selectedType: any;
  Isplanttype: boolean = false;
  IsMessage: boolean = false;
  selectedUserToUpdate: any;
  tabdata4: any;
  tabVal: any;
  tabdata3: any;
  DeleteUser: any;
  deleteUsername: any;
 
  ErrorHandler: any;
  IsdelerrMessage: boolean = false;
  IsUpderrMessage: boolean = false;
  IsAdderrMessage: boolean = false;
  UpdErrorHandler: any;
  AddErrorHandler: any;
  Formdata: any;
  Firstname: any;
  Lastname: any;
  role: any;
  errorMessage: any;
  roles: any;
  plantIds: any;
  isValidEmail = true;
  email = '';
  constructor(
    public dialogRef: MatDialogRef<LivealertsComponent>,
    readonly apiCallsService: ApiCallsService,
    public dialog: MatDialog,
    private router: Router,
 
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}
 
  async ngOnInit() {
    if (this.data.clicked == 1) {
      console.log("add user")
      this.createUSERForm();
    }
    else if (this.data.clicked == 2) {
      await this.getDropdownValue(); // Wait for dropdowns to load
    this.tabVal = this.data.tableval;
    this.tabVal.plant_id = Number(this.tabVal.plant_id);
    console.log("plant id,",this.tabVal.plant_id) // Ensure plant ID is a number
    this.editUserForm()
     
    } else if (this.data.clicked == 3) {
 
      this.DeleteUser = this.data.deleteId;
      console.log("data",this.data);
      this.deleteUsername = this.data.deleteUsername;
      console.log("delete",this.deleteUsername);
      this.Firstname =  this.data.Firstname;
      this.Lastname =  this.data.Lastname;
      this.email =  this.data.Email;
      this.role = this.data.Role
      console.log("role",this.role)
    }
  }
  UpdateUserDetails() {
    if (this.edituserForm.invalid) {
      this.edituserForm.markAllAsTouched();
      return;
    }
 
    this.isAdding = true;
    const formValue = {
      ...this.edituserForm.getRawValue(),
      user_id: this.tabVal.user_id
    };
   
    this.apiCallsService.UpdateUser(formValue).subscribe(
      (res) => {
        this.Message = res;
        console.log(res,"response")
        setTimeout(() => {
          if (this.Message.length != 0) {
            this.IsMessage = true;
          } else {
            this.IsMessage = false;
          }
        }, 100);
        setTimeout(() => {
          this.refreshUsersList();
          this.closed();
        }, 3000);
      },
      (err) => {
        console.log(err);
        this.UpdErrorHandler = err.error.Message;
        console.log(this.UpdErrorHandler);
        this.errorMessage = err.error.Message;
        setTimeout(() => {
          if (this.UpdErrorHandler.length != 0) {
            this.IsUpderrMessage = true;
          } else {
            this.IsUpderrMessage = false;
          }
        }, 500);
        setTimeout(() => {
          this.closed();
        }, 3000);
      }
    );
  }
  getDropdownValue(): Promise<void> {
    return new Promise((resolve) => {
      this.apiCallsService.getRoleList().subscribe((data) => {
        if (data) {
          this.roles = data.roles;
          this.plantIds = data.plant_id;
        }
        resolve(); // Resolve after data is set
      });
    });
  }
 
  private editUserForm() {
    console.log("edit user form");
   
    this.edituserForm = new FormGroup({
      first_name: new FormControl(this.tabVal.first_name, Validators.compose([
        Validators.required,
        Validators.pattern(/^[A-Za-z\s]+$/)
      ])),
      last_name: new FormControl(this.tabVal.last_name, Validators.compose([
        Validators.required,
        Validators.pattern(/^[A-Za-z\s]+$/)
      ])),
      username: new FormControl({value: this.tabVal.username, disabled: true}, Validators.required),
      email: new FormControl({value: this.tabVal.email, disabled: true}, Validators.compose([
        Validators.required,
        Validators.pattern(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)
      ])),
      plant_id: new FormControl(this.tabVal.plant_id, Validators.required),
      role: new FormControl(this.tabVal.role, Validators.required),
      is_active: new FormControl(this.tabVal.is_active, Validators.required),
      generate_alert_mail: new FormControl(this.tabVal.generate_alert_mail, Validators.required),
    });
  }
   
  //   // No need to manually set values since we're using ngModel in the template
  // }
  closed() {
    this.dialogRef.close();
  }
  reloadPage() {
    window.location.reload();
  }
  changePlanttype(types: any) {
    this.selectedType = [];
    this.selectedType = types.target.value;
    if (this.selectedType == "operator") {
      this.Isplanttype = true;
    } else {
      this.Isplanttype = false;
    }
  }
 
 
  AddUserDetails() {
    if (this.isAdding) return; // Prevent multiple clicks
 
    this.isAdding = true; // Disable button while processing
    console.log("add user");
    console.log("adddd ", this.userForm.value);
   
    let body = this.userForm.value;
    console.log(body);  
   
    this.apiCallsService.AddUser(body).subscribe(
      (res) => {
        this.Message = res;
        console.log(this.Message);
        setTimeout(() => {
          this.IsMessage = this.Message.length !== 0;
        }, 100);
 
        setTimeout(() => {
          this.refreshUsersList();
          this.closed();
          this.isAdding = false; // Re-enable button after success
        }, 1000);
      },
      (err) => {
        console.log(err, "error");
        this.AddErrorHandler = err.error.Message;
        this.errorMessage = err.error.Message;
        console.log(this.AddErrorHandler, "2 error");
       
        this.IsAdderrMessage = this.AddErrorHandler.length !== 0;
 
        setTimeout(() => {
          this.closed();
          this.isAdding = false; // Re-enable button after error
        }, 9000);
      }
    );
  }
  // RefreshUserList
  refreshUsersList() {
    this.apiCallsService.getAllUsers().subscribe((data) => {
      this.allUsers = data;
    });
  }
 
  // Update Userdetails Api
 
 
  DeleteUserDetails() {
    if (this.isDeleting) return; // Prevent multiple clicks
 
    this.isDeleting = true; // Disable button
    console.log("delete user:", this.deleteUsername);
   
    this.apiCallsService.DeleteUserId(this.DeleteUser, this.deleteUsername,this.email).subscribe(
      (res) => {
        this.Message = res;
        setTimeout(() => {
          this.IsMessage = this.Message.length !== 0;
        }, 100);
       
        setTimeout(() => {
          this.closed();
          this.isDeleting = false; // Re-enable button after closing
        }, 1000);
      },
      (err) => {
        this.ErrorHandler = err.error.message;
        setTimeout(() => {
          this.IsdelerrMessage = this.ErrorHandler.length !== 0;
        }, 500);
 
        setTimeout(() => {
          this.closed();
          this.isDeleting = false; // Re-enable button after closing
        }, 3000);
      }
    );
  }
 
  // Add UserForm
  private createUSERForm() {
    console.log("create user form");
    this.getDropdownValue();
 
    this.userForm = new FormGroup({
      first_name: new FormControl("", Validators.compose([
        Validators.required,
        Validators.pattern(/^[A-Za-z\s]+$/),
        Validators.maxLength(32)
      ])),
      last_name: new FormControl("", Validators.compose([
        Validators.required,
        Validators.pattern(/^[A-Za-z\s]+$/),
        Validators.maxLength(32)
      ])),
      username: new FormControl("", Validators.compose([
        Validators.required,
        Validators.minLength(4),
        Validators.maxLength(99),
        Validators.pattern(/^[A-Za-z][A-Za-z0-9._]*$/)
      ])),
      email: new FormControl('', Validators.compose([
        Validators.required,
        Validators.pattern(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)
      ])),
      role: new FormControl("", Validators.required),
      plant_id: new FormControl("", Validators.required),
      is_active: new FormControl("", Validators.required),
      generate_alert_mail: new FormControl(false, Validators.required),
    });
  }
 
}